import { Outlet } from 'react-router-dom';
import { Box, Paper } from '@mui/material';
import LanguageSwitcher from 'layout/MainLayout/Header/HeaderContent/LanguageSwitcher';

// ==============================|| MINIMAL LAYOUT ||============================== //

const MinimalLayout = () => (
    <>
        <Box
            sx={{
                position: 'fixed',
                top: 16,
                right: 16,
                zIndex: 1000
            }}
        >
            <Paper
                elevation={2}
                sx={{
                    p: 1,
                    borderRadius: 2,
                    display: 'flex',
                    alignItems: 'center'
                }}
            >
                <LanguageSwitcher />
            </Paper>
        </Box>
        <Outlet />
    </>
);

export default MinimalLayout;
